module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Modify " + _vm._s((_vm.is_amp) ? 'AMP' : 'display') + " Header Bidding tag - " + _vm._s(_vm.curUnit.dfp_ad_unit_code) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createTag.apply(null, arguments)
      }
    }
  }, [_c('h5', [_vm._v("Publisher's Unit")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "disabled": ""
    },
    model: {
      value: (_vm.isPubUnit),
      callback: function($$v) {
        _vm.isPubUnit = $$v
      },
      expression: "isPubUnit"
    }
  }, [_vm._v("Publisher's Unit")]), _vm._v(" "), _c('div', [_c('h5', [_vm._v("Select Dimension/s")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select",
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: (_vm.hb_tag.dimensions),
      callback: function($$v) {
        _vm.$set(_vm.hb_tag, "dimensions", $$v)
      },
      expression: "hb_tag.dimensions"
    }
  }, _vm._l((_vm.dimensions), function(dimension) {
    return _c('el-option', {
      attrs: {
        "data-id": dimension.id,
        "label": dimension.width + 'x' + dimension.height,
        "value": dimension.id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('hr')]), _vm._v(" "), (!_vm.isPubUnit) ? _c('div', [_c('h5', [_vm._v("Enter tag post fix")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-delay": "1000",
      "name": "post_fix",
      "type": "text",
      "placeholder": "Enter tag post fix",
      "disabled": ""
    },
    model: {
      value: (_vm.hb_tag.post_fix),
      callback: function($$v) {
        _vm.$set(_vm.hb_tag, "post_fix", $$v)
      },
      expression: "hb_tag.post_fix"
    }
  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("DFP Ad unit path:  " + _vm._s(_vm.getDfpAdUnitPath(_vm.curUnit).replace(null, '')))])]), _vm._v(" "), (_vm.is_amp) ? _c('div', [_c('h5', [_vm._v("Is AMP sticky Unit?")]), _vm._v(" "), (_vm.is_amp) ? _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.curUnit.is_amp_sticky),
      callback: function($$v) {
        _vm.$set(_vm.curUnit, "is_amp_sticky", $$v)
      },
      expression: "curUnit.is_amp_sticky"
    }
  }, [_vm._v("Is sticky Unit?")]) : _vm._e(), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.isPubUnit) ? _c('div', [_c('h5', [_vm._v("Enter publisher's DFP Ad unit path")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-delay": "1000",
      "name": "post_fix",
      "type": "text",
      "placeholder": "Enter publisher's DFP Ad unit path",
      "disabled": ""
    },
    model: {
      value: (_vm.hb_tag.pub_dfp_unit_path),
      callback: function($$v) {
        _vm.$set(_vm.hb_tag, "pub_dfp_unit_path", $$v)
      },
      expression: "hb_tag.pub_dfp_unit_path"
    }
  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), _c('div', [(_vm.domainMcmEnabled || (_vm.isPubUnit || _vm.is_amp)) ? _c('h5', [_vm._v("DFP network code override")]) : _vm._e(), _vm._v(" "), (!_vm.mcm_enabled && (_vm.isPubUnit || (!_vm.domainMcmEnabled && _vm.is_amp))) ? _c('button', {
    staticClass: "el-button el-button--success pull-right",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.resetNetworkCode($event)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v("\n                Reset to default\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.mcm_enabled && (_vm.isPubUnit || (!_vm.domainMcmEnabled && _vm.is_amp))) ? _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-delay": "1000",
      "name": "network_override",
      "type": "text",
      "placeholder": "Enter DFP network code override"
    },
    model: {
      value: (_vm.hb_tag.network_override),
      callback: function($$v) {
        _vm.$set(_vm.hb_tag, "network_override", $$v)
      },
      expression: "hb_tag.network_override"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mcm_enabled || (_vm.domainMcmEnabled && !_vm.isPubUnit)) ? _c('div', [_c('h5', [_vm._v("Is MCM Enabled?")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    on: {
      "change": _vm.resetMCM
    },
    model: {
      value: (_vm.mcm_enabled),
      callback: function($$v) {
        _vm.mcm_enabled = $$v
      },
      expression: "mcm_enabled"
    }
  }, [_vm._v("Is sticky Unit?")])], 1) : _vm._e(), _vm._v(" "), (_vm.mcm_enabled) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h5', [_vm._v("Select MCM Delegation Type:")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select MCM Delegation Type"
    },
    on: {
      "change": _vm.filterNetworkList
    },
    model: {
      value: (_vm.account_type),
      callback: function($$v) {
        _vm.account_type = $$v
      },
      expression: "account_type"
    }
  }, _vm._l((_vm.mcmAccountType), function(mcm_account_type, id) {
    return _c('el-option', {
      key: id,
      attrs: {
        "data-id": id,
        "label": mcm_account_type.account_type.replaceAll('_', ' '),
        "value": mcm_account_type.account_type
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h5', [_vm._v("Select Child DFP Network")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "disabled": _vm.account_type == null,
      "filterable": "",
      "placeholder": "Select Child DFP Network"
    },
    model: {
      value: (_vm.child_dfp_network),
      callback: function($$v) {
        _vm.child_dfp_network = $$v
      },
      expression: "child_dfp_network"
    }
  }, _vm._l((_vm.filteredAccountList), function(network) {
    return _c('el-option', {
      key: network.id,
      attrs: {
        "label": ("" + (network.child_network_code +' : ' + network.name)),
        "value": network.child_network_code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h5', [_vm._v("Add DFP Parent Adunit Id")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": _vm.account_type == null && _vm.child_dfp_network == null,
      "placeholder": "Add DFP Parent Adunit Id"
    },
    model: {
      value: (_vm.dfp_parent_ad_unit_id),
      callback: function($$v) {
        _vm.dfp_parent_ad_unit_id = $$v
      },
      expression: "dfp_parent_ad_unit_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h5', [_vm._v("Add DFP Parent Adunit Path")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": _vm.account_type == null || _vm.child_dfp_network == null || _vm.dfp_parent_ad_unit_id == 0,
      "placeholder": "Add DFP Parent Adunit Path"
    },
    model: {
      value: (_vm.dfp_parent_ad_unit_path),
      callback: function($$v) {
        _vm.dfp_parent_ad_unit_path = $$v
      },
      expression: "dfp_parent_ad_unit_path"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('hr')], 1), _vm._v(" "), (_vm.is_amp) ? _c('div', [_c('h5', [_vm._v("Select Currency for AMP")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.hb_tag.currencyId),
      callback: function($$v) {
        _vm.$set(_vm.hb_tag, "currencyId", $$v)
      },
      expression: "hb_tag.currencyId"
    }
  }, _vm._l((_vm.currenciesOptions), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option.code,
        "value": option.id
      }
    })
  }), 1), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.isPubUnit) ? _c('div', [_c('h5', [_vm._v("Enter publisher's DFP Ad unit id")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-delay": "1000",
      "name": "post_fix",
      "type": "text",
      "placeholder": "Enter publisher's DFP Ad unit id",
      "disabled": ""
    },
    model: {
      value: (_vm.hb_tag.pub_dfp_unit_id),
      callback: function($$v) {
        _vm.$set(_vm.hb_tag, "pub_dfp_unit_id", $$v)
      },
      expression: "hb_tag.pub_dfp_unit_id"
    }
  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (((_vm.mcm_enabled && _vm.domainMcmEnabled == false) || (_vm.isPubUnit == true && _vm.mcm_enabled == true))) ? _c('div', {
    staticClass: "mcm-update-error"
  }, [_vm._v("\n                Remove MCM Network Override to Update this HB Tag\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('button', {
    staticClass: "el-button el-button--success",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isComplete
    }
  }, [_c('i', {
    staticClass: "el-icon-left"
  }), _vm._v("\n                Update tag\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "el-button el-button--danger",
    attrs: {
      "to": (_vm.is_amp) ? ("/admin/publisher/" + (this.pubUuid) + "/domain/" + (this.domId) + "/hb-tags-amp/") : ("/admin/publisher/" + (this.pubUuid) + "/domain/" + (this.domId) + "/hb-tags/")
    }
  }, [_vm._v("\n                Cancel\n              ")])], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f6aba4c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dfp/ModifyHbTag.vue
// module id = 702
// module chunks = 2